"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ControlledAccordion = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
require("core-js/modules/es6.array.map.js");
var _snakeCase2 = _interopRequireDefault(require("lodash/snakeCase"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PanelGroup = _interopRequireDefault(require("react-bootstrap/lib/PanelGroup"));
var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));
var _accordionItem = _interopRequireWildcard(require("./accordion-item"));
var _excluded = ["key"];
var BaseAccordion = function BaseAccordion(_ref) {
  var AccordionItemComponent = _ref.AccordionItemComponent,
    analytics = _ref.analytics,
    enableAnalytics = _ref.enableAnalytics,
    enableTracking = _ref.enableTracking,
    id = _ref.id,
    items = _ref.items,
    sectionCategory = _ref.sectionCategory;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classes.default)('border-top-1', 'border-neutral-lighter', 'margin-horizontal-0')
  }, /*#__PURE__*/_react.default.createElement(_PanelGroup.default, {
    id: id
  }, items.map(function (_ref2, index) {
    var key = _ref2.key,
      item = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
    return /*#__PURE__*/_react.default.createElement(AccordionItemComponent, (0, _extends2.default)({
      analytics: analytics,
      id: "".concat(id, "_").concat(key || (0, _snakeCase2.default)(item.title)),
      index: index,
      onSelect: item.onSelect,
      enableAnalytics: enableAnalytics,
      enableTracking: enableTracking,
      key: key || (0, _snakeCase2.default)(item.title),
      sectionCategory: sectionCategory
    }, item));
  })));
};
BaseAccordion.propTypes = {
  /**
   * Which AccordionItem component to use (ie. AccordionItem or ControlledAccordionItem)
   */
  AccordionItemComponent: _propTypes.default.oneOf([_accordionItem.default, _accordionItem.ControlledAccordionItem]).isRequired,
  /**
   * Whether we would like dispatch when bedrock analytics when the panel is expanded or collapsed.
   * @deprecated  Use the enabled flag the analytics prop.
   */
  enableAnalytics: _propTypes.default.bool,
  /**
   * The content used by that analytics module and the flag to determine if analytics is sent
   */
  analytics: _propTypes.default.shape({
    enabled: _propTypes.default.bool,
    payload: _propTypes.default.shape({
      elementName: _propTypes.default.string,
      sectionName: _propTypes.default.string,
      sectionPosition: _propTypes.default.number
    })
  }),
  /**
   * Flag to indicate if we should fire element interaction events from this Accordion. See the
   * tracking element shape in AccordionItem.
   */
  enableTracking: _propTypes.default.bool,
  /**
   * Unique identifier supplied to Bootstrap PanelGroup. In order to properly initialize
   * the PanelGroup in a way that is accessible to assistive technologies (such as screen readers) an `id`
   * is required.
   */
  id: _propTypes.default.string.isRequired,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * The AccordionItem content.
     */
    children: _propTypes.default.node.isRequired,
    /**
     * The key to be used for rendering. If not provided, the snake-cased title will be used.
     * Note: this is required if `title` is not a string.
     */
    key: function key(props, propName, componentName) {
      var key = props[propName],
        title = props.title;
      if (typeof title !== 'string' && !key) {
        return new Error("Prop ".concat(propName, " is required when \"title\" is not a string for ").concat(componentName));
      }
      return null;
    },
    /**
     * Callback to be invoked when an AccordionItem is selected.
     */
    onSelect: _propTypes.default.func,
    /**
     * The header string of the AccordionItem.
     */
    title: _propTypes.default.node.isRequired
  })).isRequired,
  /**
   * Used for element interaction tracking to indicate where on page the Accordion is.
   */
  sectionCategory: _propTypes.default.string
};
BaseAccordion.defaultProps = {
  analytics: {
    enabled: false
  },
  enableAnalytics: false,
  enableTracking: false,
  sectionCategory: null
};
var Accordion = function Accordion(props) {
  return /*#__PURE__*/_react.default.createElement(BaseAccordion, (0, _extends2.default)({
    AccordionItemComponent: _accordionItem.default
  }, props));
};
Accordion.displayName = 'Accordion';
var ControlledAccordion = function ControlledAccordion(props) {
  return /*#__PURE__*/_react.default.createElement(BaseAccordion, (0, _extends2.default)({
    AccordionItemComponent: _accordionItem.ControlledAccordionItem
  }, props));
};
exports.ControlledAccordion = ControlledAccordion;
ControlledAccordion.displayName = 'ControlledAccordion';
var _default = Accordion;
exports.default = _default;